import { formatLocalDate } from "src/utils/common";

class ReservationSummaryModel {
    constructor(item) {
        this.Id = item?.Id ?? null;
        this.ReservationNumber = item?.ReservationNumber ?? null;
        this.ReservationReference = item?.ReservationReference ?? null;
        this.Status = item?.Status ?? null;
        this.CreatedDate = item?.CreatedDate ? formatLocalDate(item.CreatedDate) : null;
        this.PropertyName = item?.PropertyName ?? null;
        this.Name = item?.Metadata?.Name ?? null;
        this.NetSellTotal = Number(item?.Metadata?.ClientSell?.Total) || 0;
        this.Types = item?.Metadata?.Types ?? null;
        this.CheckIn = item?.CheckIn ? formatLocalDate(item.CheckIn) : null;
        this.CheckOut = item?.CheckOut ? formatLocalDate(item.CheckOut) : null;
        this.ClientSellTotal = Number(item?.ClientSell?.Total) || 0;
        this.CreatedUserName = item?.CreatedUser?.DisplayName ?? null;
    }
}

export default ReservationSummaryModel;
